import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, change as changeFieldValue, formValueSelector } from "redux-form";
import { FormattedMessage, intlShape } from "react-intl";
import { CloseFollowUp } from "./";
import { TextInput, SelectInput } from "../../../../common/form";

import {
  USERS,
  FOLLOW_UP_CATEGORIES,
  MEMBERS_GRAPHQL,
} from "../../../../../utils/data/models";
import * as dataActions from "../../../../../utils/data/dataActions";
import {
  buildGraphQLQueryParams,
  toGraphQLFormat,
  toGraphQLSortFormat,
} from "../../../../common/GraphQL/GraphQLQueryHelper";
import api from "../../../../../utils/data/dataApi";
import * as searchActions from "../../../../dashboard/search/searchActions";
import _ from "lodash";

const formName = "memberNote";
class NoteFollowUp extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
          members: [],
          searchKey: 0 
          /** This key is incremented every time 
          clientId dropdown value is changed, it forces a re render of the memberId field, in order to clear the text value.
         react-select-virtualized does not allow to clear the text value programatically **/
        };

        this.getMember = this.getMember.bind(this);
        this.validateRecipientUser = this.validateRecipientUser.bind(this);
        this.memberTextSearch = _.debounce(this.memberTextSearch.bind(this), 250);
    }

    componentWillMount() {
        const { followUpStatusType, readOnly } = this.props;
        const userFilters = [USERS.planManagerFilter, USERS.informationAgentFilter];
        const isClosed = followUpStatusType == "CLOSED";
    
        if (!isClosed && ! readOnly) {
            userFilters.push(USERS.archiveFilter);
        }
    
        this.props.dataActions.getDataList(
            FOLLOW_UP_CATEGORIES,
            0,
            0,
            "",
            ["followUpCategoryOrder:asc"],
            [FOLLOW_UP_CATEGORIES.categorizeFilter]
        );

        this.props.dataActions.getDataList(
            USERS,
            0,
            0,
            "",
            ["firstName:asc", "lastName:asc"],
            userFilters,
            {},
            {},
            "userId,firstName,lastName"
        );
    }

    componentDidMount() {
        const { memberId, clientId, isEdit, type } = this.props;
        const isAddingFromMemberPage = !isEdit && type === "member";
        if(memberId && clientId && isEdit || isAddingFromMemberPage) {
            this.getMember(clientId);
        }
    }
    
    componentWillUnmount() {
        this.props.searchActions.clearResults();
    }

    getMember(clientId) {
      const { memberId } = this.props;
      const colsStr = `
                  memberId
                  memberNameMemberIdentifier
                  fullName
                  memberIdentifier`;
                  /** Do not remove fullName from request. If we have a case where memberIdentifier == null, memberNameMemberIdentifier is set as null
                   * by SQLAlchemy (virtual columm). We will instead display the fullName */
      let filters = [
        `members.clientId==${clientId}`,
        `members.member_id==${memberId}`,
      ];
      filters = toGraphQLFormat(filters);
      let sortBy = ["members.memberNameMemberIdentifier:asc"];
      sortBy = toGraphQLSortFormat(sortBy, true);
      const graphQLQuery = buildGraphQLQueryParams(
        "members",
        filters,
        sortBy,
        0,
        0,
        colsStr,
        "getMembers"
      );
      api
        .getGraphQL(MEMBERS_GRAPHQL, { query: graphQLQuery })
        .then((response) => {
          this.setState({ members: response.data.members.items });
        });
    }

    memberTextSearch(q="") {
        const isMembersArrayFilled = this.state.members && this.state.members.length > 0;
        const isFormSelectionEmpty = !this.props.formMemberId || (typeof this.props.formMemberId === "string" && 
            !!this.props.formMemberId.trim() === false);
        if(isMembersArrayFilled && isFormSelectionEmpty && (!q || (q && q.trim().length < 3))) {
            this.setState({members: []});
            return;
        }
        if(q === "") return;

    if(q && q.length >= 3) {
        this.props.searchActions.searchMembersForFollowUps(
            0,
            0,
            q.trim(),
            ["members_client_fts.member_first_name:asc;members_client_fts.member_last_name:asc"],
            [`members_client_fts.client_id==${this.props.formClientId};members_client_fts.is_archived==false`]
            ).then((res) => {
                let members = res.payload.data.data.membersClientFts.items;
                this.setState({ members });
            });
    }
    }

    handleClientChange() {
      this.props.changeFieldValue(formName, "memberIdentifier", null);
      this.props.changeFieldValue(formName, "memberId", null);
      this.setState({members: [], searchKey: this.state.searchKey + 1});
    }
    handerMemberChange(event) {
        const value = event.target.value;
        if (value === " ") {
            this.props.changeFieldValue(formName, "memberIdentifier", null);
            this.setState({members: []});
        } else {
            const currentMember = this.state.members.filter((member) => member.memberId == value);
            this.props.changeFieldValue(formName, "memberIdentifier", currentMember[0].memberIdentifier);
        }
    }
    validateRecipientUser = (value) => {
        const filteredUsers = this.props.userList.filter(user => user.userId == value);
        if (filteredUsers.length == 0) {
            return {"messageKey": "validation.isRequiredTrim"};
        }
        return undefined;
    }
    render() {
        const users = this.props.userList.map((user) => {
            return { value: user.userId, text: `${user.firstName} ${user.lastName}` };
        });
        const categories = this.props.followUpCategoryList
            .sort((a, b) => a.followUpCategoryOrder - b.followUpCategoryOrder)
            .map((category) => {
                return {
                    value: category.followUpCategoryId,
                    text: category.localizations[this.props.languageCode].name,
                };
            });
        const { clients, isEdit , clientId , memberId, formClientId } = this.props;
        const hasClient = clientId != undefined;
        const hasMember = memberId != undefined;
        let sortedMembers = this.state.members;
        if(sortedMembers) {
            if(hasMember) {
                sortedMembers = sortedMembers.map((member) => {
                    return {
                      value: member.memberId,
                      text: member && member.memberNameMemberIdentifier ? member.memberNameMemberIdentifier : member.fullName,
                    };
                  });
            }
            else {
                sortedMembers = sortedMembers.map((member) => {
                    let text = `${member.memberFirstName} ${member.memberLastName}`;
                    if (member.memberIdentifier) text += `/ ${member.memberIdentifier}`;
                    return {
                        value: member.memberId,
                        text
                    };
                  });
            }

        }      
        const isClosed = this.props.followUpStatusType == "CLOSED";
        return (
            <div className="note-follow-up">
                <div className="contact-info-field-group">
                    <h5>
                        <FormattedMessage id="members.followUps.form.followUpInformation" />
                    </h5>
                    {clients && (
                        <Field
                            id="clientId"
                            name="clientId"
                            component={SelectInput}
                            searchable={true}
                            addBlankOption={true}
                            options={clients}
                            required={true}
                            disabled={isClosed || this.props.readOnly || isEdit || hasClient}
                            props={{ onChange: this.handleClientChange.bind(this) }}
                            label={<span><FormattedMessage id="members.followUps.form.clientName" />  {hasClient &&(<a href={`/dashboard/clients/${clientId}`} target="_blank"><span className="icon-eye" /></a>)}</span>}
                            groupClassName="required-line"
                        />

                    )}
                    {clients && sortedMembers && (
                        <Field
                            id="memberId"
                            name="memberId"
                            component={SelectInput}
                            searchable={true}
                            addBlankOption={true}
                            options={sortedMembers}
                            asyncSearch={!hasMember ? this.memberTextSearch : undefined}
                            customPlaceHolder="asyncSearchWithoutEnter"
                            optionalProps={{key: this.state.searchKey, noResultsText: <FormattedMessage id="search.noResults"/>}}
                            disabled={isClosed || this.props.readOnly || hasMember || !formClientId || (typeof formClientId === 'string' && formClientId.trim() === "")}
                            props={{ onChange: this.handerMemberChange.bind(this) }}
                            label={<span><FormattedMessage id="members.followUps.form.memberName" />  {hasClient && hasMember &&(<a href={`/dashboard/clients/${clientId}/members/${memberId}/profile`} target="_blank"><span className="icon-eye" /></a>)}</span>}
                            groupClassName="required-line"
                        />
                    )}
                    {clients && sortedMembers && (
                        <Field
                            id="memberIdentifier"
                            name="memberIdentifier"
                            type="text"
                            component={TextInput}
                            disabled={true}
                            label={<FormattedMessage id="members.followUps.form.memberIdentifier" />}
                        />
                    )}
                </div>
                <div
                    className="contact-info-field-group"
                    style={{ paddingTop: "15px", borderTop: "1px solid #dcdcdc" }}
                >
                    <Field
                        id="recipientUserId"
                        name="recipientUserId"
                        component={SelectInput}
                        validate={this.validateRecipientUser}
                        searchable={true}
                        required={true}
                        addBlankOption={true}
                        options={users}
                        disabled={isClosed || this.props.readOnly}
                        label={<FormattedMessage id="members.followUps.form.followUpRecipient" />}
                        groupClassName="required-line"
                    />
                </div>
                <div className="contact-info-field-group">
                    <Field
                        id="followUpCategoryId"
                        name="followUpCategoryId"
                        component={SelectInput}
                        sortOptions={false}
                        searchable={true}
                        required={true}
                        addBlankOption={true}
                        options={categories}
                        disabled={isClosed || this.props.readOnly}
                        label={<FormattedMessage id="members.followUps.form.category" />}
                    />
                </div>
                {this.props.followUpStatusType != "NEW" && !this.props.readOnly && (
                    <CloseFollowUp
                        closeFollowUp={this.props.closeFollowUp}
                        closedDescription={this.props.closedDescription}
                        followUpStatusType={this.props.followUpStatusType}
                    />
                )}
            </div>
        );
    }
}

NoteFollowUp.propTypes = {
    clientId: PropTypes.number,
    closedDescription: PropTypes.string,
    closeFollowUp: PropTypes.bool,
    dataActions: PropTypes.object,
    disabledFollowUpFields: PropTypes.bool,
    followUpOriginType: PropTypes.string,
    followUpStatusType: PropTypes.string,
    memberId: PropTypes.number,
    member: PropTypes.object,
    userList: PropTypes.array,
    readOnly: PropTypes.bool,
    isEdit: PropTypes.bool,
    type: PropTypes.string,
    memberClientId: PropTypes.number,
    followUpCategoryList: PropTypes.array,
    languageCode: PropTypes.string,
    handleClientChange: PropTypes.func,
    handleMemberChange: PropTypes.func,
    changeFieldValue: PropTypes.func,
    members: PropTypes.array,
    searchActions: PropTypes.object,
    formClientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    formMemberId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    clients: PropTypes.array
};

NoteFollowUp.defaultProps = {
    disabledFollowUpFields: false,
};

SelectInput.contextTypes = {
	intl: intlShape,
};

function mapStateToProps(state) {
    const userData = state.data.users || {};
    const followUpCategoryData = state.data.followUpCategories || {};
    const languageCodeData = state.auth.user.languageCode || "en-CA";

    const formSelector = formValueSelector(formName);

    return {
        userList: userData.items || [],
        followUpCategoryList: followUpCategoryData.items || [],
        languageCode: languageCodeData,
        formClientId: formSelector(state, "clientId"),
        formMemberId: formSelector(state, "memberId")
    };
}

function mapDispatchToProps(dispatch) {
    return {
        searchActions: bindActionCreators(searchActions, dispatch),
        dataActions: bindActionCreators(dataActions, dispatch),
        changeFieldValue: bindActionCreators(changeFieldValue, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NoteFollowUp);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/NoteFollowUp.js